<template>
  <div class="page-content">
     <div class="container-fluid">
        <div class="row">
           <div class="col-12">
              <div class="page-title-box d-flex align-items-center justify-content-between">
                 <h4 class="mb-0 font-size-18">Server Addons</h4>
                 <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                       <li class="breadcrumb-item"><a href="javascript: void(0);">Your Server</a></li>
                       <li class="breadcrumb-item active">Addons</li>
                    </ol>
                 </div>
              </div>
           </div>
        </div>
        <!-- end page title -->
        <div class="row">
           <div class="col-lg-4">
              <div class="card">
                 <h5 class="card-header mt-0">Custom Domain</h5>
                 <div class="card-body">
                    <h4 class="card-title mt-0"><big>£ </big>0.99/month</h4>
                    <p class="card-text">Allows the ability to utilize your own custom domain for your server address.</p>
                    <div class="text-sm-right">
                       <a href="#" class="btn btn-success">Activate</a>
                    </div>
                 </div>
              </div>
           </div>
           <div class="col-lg-4">
              <div class="card">
                 <h5 class="card-header mt-0">Remove Ads</h5>
                 <div class="card-body">
                    <h4 class="card-title mt-0"><big>£ </big>0.99/month</h4>
                    <p class="card-text">Hides all advertisements present on SpaceMine's panel for an undisturbed control.</p>
                    <div class="text-sm-right">
                       <a href="#" class="btn btn-danger">Deactivate</a>
                    </div>
                 </div>
              </div>
           </div>
           <div class="col-lg-4">
              <div class="card">
                 <h5 class="card-header mt-0">Remove SpaceMine Branding</h5>
                 <div class="card-body">
                    <h4 class="card-title mt-0"><big>£ </big>0.99/month</h4>
                    <p class="card-text">Allows for a completely whitelabeled control panel, removing all SpaceMine branding.</p>
                    <div class="text-sm-right">
                       <a href="#" class="btn btn-success">Activate</a>
                    </div>
                 </div>
              </div>
           </div>
           <div class="col-lg-4">
              <div class="card">
                 <h5 class="card-header mt-0">Custom Software</h5>
                 <div class="card-body">
                    <h4 class="card-title mt-0"><big>£ </big>0.99/month</h4>
                    <p class="card-text">Allows the ability to upload and utilize your own custom JAR for your server.</p>
                    <div class="text-sm-right">
                       <a href="#" class="btn btn-success">Activate</a>
                    </div>
                 </div>
              </div>
           </div>
           <div class="col-lg-4">
              <div class="card">
                 <h5 class="card-header mt-0">RAM Boost</h5>
                 <div class="card-body">
                    <h4 class="card-title mt-0"><big>£ </big>0.99/month</h4>
                    <p class="card-text">Allows for sudden bursts of RAM, providing servers with extra performance when needed.</p>
                    <div class="text-sm-right">
                       <a href="#" class="btn btn-success">Activate</a>
                    </div>
                 </div>
              </div>
           </div>
           <div class="col-lg-4">
              <div class="card">
                 <h5 class="card-header mt-0">Antivirus Checks</h5>
                 <div class="card-body">
                    <h4 class="card-title mt-0"><big>£ </big>0.99/month</h4>
                    <p class="card-text">Checks and manages your Minecraft server to validate files, free from viruses.</p>
                    <div class="text-sm-right">
                       <a href="#" class="btn btn-danger">Deactivate</a>
                    </div>
                 </div>
              </div>
           </div>
           <div class="col-lg-4">
              <div class="card">
                 <h5 class="card-header mt-0">Server Doctor</h5>
                 <div class="card-body">
                    <h4 class="card-title mt-0"><big>£ </big>0.99/month</h4>
                    <p class="card-text">Optimizes your Minecraft server to provide the best performance achievable.</p>
                    <div class="text-sm-right">
                       <a href="#" class="btn btn-success">Activate</a>
                    </div>
                 </div>
              </div>
           </div>
        </div>
     </div>
  </div>
</template>

<script>
export default {
  name: 'Addons',
  data () {
    return { }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/panel/Addons.vue